<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Add unit</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal needs-validation" novalidate id="form_add_unit">
        <div class="mb-3">
          <label class="col-md-12">Unit name</label>
          <div class="col-md-12">
            <input type="text" class="form-control form-control-fix" placeholder="unit name" v-model="name" required />
            <div class="invalid-feedback">Please enter unit name.</div>
          </div>
        </div>
        <div class="mb-3">
          <label class="col-md-12">Unit status</label>
          <div class="col-md-12">
            <select v-model="is_active" class="form-control-line form-select form-select-fix" style="width: 100%" placeholder="Choose status..." required>
              <option selected value="1">Active</option>
              <option selected value="0">Inactive</option>
            </select>
            <div class="invalid-feedback">Please select a valid unit status.</div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-fix" data-bs-dismiss="modal" id="cls_btn"><i class="fa fa-times"></i> Close</button>
      <button type="button" class="btn btn-info btn-fix" id="act_btn" @click="addUnit"><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/unit'

export default {
  props: ['search', 'data'],
  data() {
    return {
      name: '',
      is_active: 1
    }
  },
  mounted() {
    this.name = this.data.name
    this.is_active = this.data.is_active
    $('#form_add_unit').removeClass('was-validated')
  },
  watch: {
    data: function (val, old_val) {
      this.name = val.name
      this.is_active = val.is_active
      $('#form_add_unit').removeClass('was-validated')
    }
  },
  methods: {
    addUnit() {
      if (this.name !== '') {
        $('#act_btn').prop('disabled', true)
        let form_data = {
          name: this.name,
          is_active: this.is_active
        }
        api.addUnit(
          this.$store.state.URLHost,
          form_data,
          this.header,
          (result) => {
            if (result.response === true) {
              this.alert_msg('success', 'Successful.', result.message)
            } else {
              this.alert_msg('error', 'An error occurred.', result.message)
            }
            this.search()
            $('#act_btn').prop('disabled', false)
            $('#unit_modal').modal('hide')
          },
          (error) => {
            this.alert_msg('error', 'An error occurred.', error.message)
            this.search()
            $('#act_btn').prop('disabled', false)
            $('#unit_modal').modal('hide')
          }
        )
      } else {
        $('#form_add_unit').addClass('was-validated')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/unit_add_modal.vue